/**
 * Importação da biblioteca axios para fazer requisições baseadas em Promises.
 */
import axios from 'axios';

/**
 * Classe que realiza as requisições dos metadados de uma camada
 */
export default class LayerMetadata {
  /**
   * Método de requisição dos metadados de uma camada
   *
   * @param {String} uri
   */
  static get(uri) {
    return axios(`${process.env.REACT_APP_API_HOST}/v1/request-xml-json`, {
      params: {
        uri,
      },
    });
  }
}
